<template>
  <v-dialog
    v-if="expediente"
    v-model="active"
    width="90%"
    persistent
  >
    <v-card color="primary">
      <v-card-title>
        <div class="text-h6 mr-6">
          Expediente #{{ expediente.folio }}
        </div>
        <v-spacer />
        <v-spacer />
        <v-btn
          icon
          color="error"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-tabs
          v-model="tabs"
          color="secondary"
          slider-color="secondary"
        >
          <v-tab>Información general</v-tab>
          <v-tab>Biométricos</v-tab>
          <v-tab>Puesto y dependencia</v-tab>
          <v-tab>Documentos</v-tab>
          <v-tab>Antecedentes</v-tab>
          <v-tab>Evaluaciones</v-tab>
        </v-tabs>
        <v-tabs-items
          v-model="tabs"
          class="primary"
        >
          <v-tab-item key="0">
            <informacion-general-tab-component
              :personal="expediente.Personal"
              @update-personal="updatePersonalInfo($event)"
            />
          </v-tab-item>
          <v-tab-item key="1">
            <biometricos-tab-component />
          </v-tab-item>
          <v-tab-item key="2">
            <puesto-dependencia-tab-component :personal="expediente.Personal" />
          </v-tab-item>
          <v-tab-item key="3">
            <documentos-tab-component :personal="expediente.Personal" />
          </v-tab-item>
          <v-tab-item key="4">
            <antecedentes-tab-component
              :personal="expediente.Personal"
              :id-expediente="expediente.idExpediente"
            />
          </v-tab-item>
          <v-tab-item key="5">
            <evaluaciones-tab-component />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapMutations } from 'vuex';
import InformacionGeneralTabComponent from './informacion_general/InformacionGeneralTabComponent.vue';
import BiometricosTabComponent from './biometricos/BiometricosTabComponent.vue';
import PuestoDependenciaTabComponent from './puesto_dependencia/PuestoDependenciaTabComponent.vue';
import DocumentosTabComponent from './documentos/DocumentosTabComponent.vue';
import AntecedentesTabComponent from './antecedentes/AntecedentesTabComponent.vue';
import EvaluacionesTabComponent from './evaluaciones/EvaluacionesTabComponent.vue';

export default {
  components: {
    InformacionGeneralTabComponent,
    BiometricosTabComponent,
    PuestoDependenciaTabComponent,
    DocumentosTabComponent,
    AntecedentesTabComponent,
    EvaluacionesTabComponent,
  },

  props: {
    active: {
      type: Boolean,
    },

    expediente: {
      type: Object,
      default() {
        return {
          folio: '000',
        };
      },
    },
  },

  data() {
    return {
      tabs: 0,
    };
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    closeDialog() {
      this.$emit('close');
    },

    updatePersonalInfo(e) {
      if (e.length > 0) {
        e[0].cib = String(e[0].idPersonal);
        e[0].fk_idCatArea = null;
        e[0].fk_idCatSubArea = null;
        delete e[0].idPersonal;
        this.expediente.Personal = {
          ...e[0],
          idPersonal: this.expediente.Personal.idPersonal,
        };
      } else {
        this.SET_SNACKBAR_MESSAGE('No se encontraron resultados en personal.');
      }
    },
  },
};
</script>
